export default __webpack_public_path__ + "assets/logo-blockchain-lightcolor-edf45d34c42a72aefae97e0e624f6160.svg";